export const PRODUCT_NAME = {
  singular: "Slate",
  plural: "Slates",
  possessive: "Slate's",
} as const;
